import Address from './index';
import _ from 'lodash';

class AutocompleteWrapper extends Address {
  componentDidMount() {
    const input = document.getElementById(this.props.inputId);

    // prevent accidental form submission
    google.maps.event.addDomListener(input, 'keydown', (e) => {
      if (e.which == 13) {
        const dropdownNodes = document.getElementsByClassName('pac-container');
        if (_.some(dropdownNodes, (node) => node.offsetParent !== null)) {
          e.preventDefault();
          return false;
        }
      }
    });

    this.autocomplete = new google.maps.places.Autocomplete(input, {types: ['geocode']});
    this.autocomplete.addListener('place_changed', this.fillInAddress.bind(this));
  }

  render() {
    return this.props.children || null;
  }
}

export default AutocompleteWrapper
